export const surfaceTokens = ['base', 'elevated', 'focus'] as const;

export type StatusTone = 'success' | 'warning' | 'danger' | 'neutral';

export function getStatusTone(status: string): StatusTone {
  const normalized = status.trim().toLowerCase();

  if (normalized === 'healthy' || normalized === 'running' || normalized === 'success') {
    return 'success';
  }

  if (normalized === 'warning' || normalized === 'queued') {
    return 'warning';
  }

  if (normalized === 'failed' || normalized === 'error') {
    return 'danger';
  }

  return 'neutral';
}
